import { Link, useNavigate } from '@tanstack/react-router';
import { Menu, Bell, Settings, LogOut, ChevronDown } from 'lucide-react';
import { useUIStore } from '@/shared/stores/ui-store';
import { useAuthStore } from '@/shared/stores/auth-store';
import { useLogout } from '@/shared/hooks/use-logout';
import { AppDropdownMenu } from '@/shared/components/ui/AppDropdownMenu';
import styles from './AppHeader.module.scss';

export function AppHeader() {
  const toggleSidebar = useUIStore((s) => s.toggleSidebar);
  const toggleMobileSidebar = useUIStore((s) => s.toggleMobileSidebar);
  const user = useAuthStore((s) => s.user);
  const navigate = useNavigate();
  const handleLogout = useLogout();

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <button
          className={styles.menuButton}
          onClick={() => {
            // On mobile: open/close sidebar overlay
            // On desktop: collapse/expand sidebar
            if (window.innerWidth <= 768) {
              toggleMobileSidebar();
            } else {
              toggleSidebar();
            }
          }}
          aria-label="Toggle sidebar"
          type="button"
        >
          <Menu size={20} />
        </button>
      </div>

      <div className={styles.right}>
        <Link to="/promote/notifications" className={styles.iconButton} aria-label="Notifications">
          <Bell size={18} />
        </Link>

        {user && (
          <AppDropdownMenu
            trigger={
              <button className={styles.userInfo} type="button">
                <span className={styles.avatar}>
                  {user.firstName.charAt(0)}
                  {user.lastName.charAt(0)}
                </span>
                <span className={styles.userName}>
                  {user.firstName} {user.lastName}
                </span>
                <ChevronDown size={14} className={styles.chevron} />
              </button>
            }
            items={[
              {
                label: 'Settings',
                icon: <Settings size={16} />,
                onClick: () => navigate({ to: '/promote/settings' }),
              },
              {
                label: 'Log out',
                icon: <LogOut size={16} />,
                onClick: handleLogout,
                destructive: true,
              },
            ]}
          />
        )}
      </div>
    </header>
  );
}
